import './Styles.css';
import React, { useState, useEffect } from "react";
import {Button, Select, Switch, MenuItem, TextField, FormGroup, FormControlLabel, FormControl, Box, Grid, IconButton} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const Forms = ({onSubmit, onCancel, editEndpoint, endpts}) => {
    const initialInputState = {
        Name: "", Url:"", Method:"", TokenType:"",
        TokenRenewalUrl:"", TokenHeader:"", ApiKey:"", Ssl: true, Payload: {}, CreatedBy: "system", UpdatedBy: "system"};
    const [eachEntry, setEachEntry] = useState(initialInputState);
    const {Name, Url, Method, TokenType, TokenRenewalUrl, TokenHeader, ApiKey, Ssl} = eachEntry;
    const [payloadRows, setPayloadRows] = useState([]);
    const [nameError, setNameError] = useState(false);

    const handleAddRow = () => {
      setPayloadRows([...payloadRows, { text1: '', text2: '' }]);
    };

    const handleDeleteRow = (index) => {
      var plr = payloadRows.filter((_, i) => i !== index)
      setPayloadRows(plr);
      const newPayload = plr.reduce((acc, item) => {
        acc[item.text1] = item.text2;
        return acc;
      }, {});
      // console.log(newPayload)
      setEachEntry({ ...eachEntry, "Payload": newPayload });
    };

    const handleChange = (index, field, value) => {
      // Update UI payload format
      // console.log(payloadRows)
      var newRows = []
      payloadRows.forEach((row, i) => {
        console.log(row[field])
        if (i === index) {
          console.log(row[field])
          row[field] = value
          console.log(row[field])
        }
        newRows.push(row)
      });
      setPayloadRows(newRows);
      // Update entry payload below
      // console.log(newRows)
      const newPayload = newRows.reduce((acc, item) => {
        acc[item.text1] = item.text2;
        return acc;
      }, {});
      // console.log(newPayload)
      setEachEntry({ ...eachEntry, "Payload": newPayload });
    };

    // updating eachEntry each time editEndpoint changes
    useEffect(() => {
      if (editEndpoint) {
        console.log(editEndpoint)
        setEachEntry(editEndpoint);
        if (editEndpoint.Payload != null){
          var tempPayloadRows = []
          Object.entries(editEndpoint.Payload).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            tempPayloadRows.push({text1: key, text2: value})
          });
          setPayloadRows(tempPayloadRows)
        }
        console.log('changed');
      }
    }, [editEndpoint]);

  console.log(eachEntry);

  // handling input changes - can set errors here
  const handleInputChange = (e) => {
    setEachEntry({ ...eachEntry, [e.target.name]: e.target.value });
    const arrEpNames = !editEndpoint
  ? endpts.map(endpoint => endpoint.Name)
  : endpts.map(endpoint => endpoint.Name).filter(name => name !== editEndpoint.Name);

    console.log(arrEpNames)
    // prevent same endpoint name
    console.log(editEndpoint);
   if (e.target.name === 'Name' && arrEpNames.includes(e.target.value)){
    setNameError(true);
   }
   else{
    setNameError(false);
   }
  };

  // handling switch changes
  const handleSwitchChange = (e) => {
    setEachEntry({ ...eachEntry, [e.target.name]: e.target.checked });
  }

  // handling submit
  const handleFinalSubmit = (e) => {
    e.preventDefault();
    onSubmit(eachEntry);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    onCancel(editEndpoint);
    setEachEntry(initialInputState);
  }

  return (
    <div className="formContainer">
      <hr style={{width: '100%',marginTop: '2%' }}/>
      <div className="submitButton">
        {editEndpoint ? <h1>Edit End Point</h1> : <h1>Create New End Point</h1>}
        <div className='TopButtons'>
          <Button onClick={handleCancel}>CANCEL</Button>
          <Button disabled={nameError} onClick={handleFinalSubmit}>SUBMIT</Button>
        </div>
      </div>
        <FormControl component="fieldset" className="formGroup">
            <FormGroup className="formGroup">
              <div className="formInput">
                <label>Name</label>
                <TextField
                name="Name"
                value={Name}
                onChange={handleInputChange}
                error={nameError}
                helperText={nameError && "There is already an endpoint with this name."}
                />
              </div>
              <div className="formInput">
                <label>URL</label>
                <TextField
                name="Url"
                value={Url}
                onChange={handleInputChange}
                required={true}
                />
              </div>
              <div className="formInput">
              <label>Method</label>
                <FormControl>
                <Select
                  name="Method"
                  value={Method}
                  onChange={handleInputChange}>
                      <MenuItem value = "POST">POST</MenuItem>
                      <MenuItem value = "GET">GET</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="formInput">
                <label>Token Type</label>
                <FormControl>
                <Select
                  name="TokenType"
                  value={TokenType}
                  onChange={handleInputChange}>
                      <MenuItem value = "Fixed Token">Fixed Token</MenuItem>
                      {/* <MenuItem value = "B">B</MenuItem> */}
                  </Select>
                </FormControl>
              </div>
              <div className="formInput">
                <label>Token Renewal URL</label>
                <TextField
                name="TokenRenewalUrl"
                value={TokenRenewalUrl}
                onChange={handleInputChange}
                />
              </div>
              <div className="formInput">
                <label>Token Header</label>
                <TextField
                name="TokenHeader"
                value={TokenHeader}
                onChange={handleInputChange}
                />
              </div>
              {/* <div className="formInput"> */}
              <Box p={2}>
                {payloadRows.map((row, index) => (
                  <Grid container alignItems="center" spacing={1} key={index}>
                    <Grid item>
                      <TextField
                        label="Payload"
                        name="Payload"
                        value={row.text1}
                        onChange={(e) => handleChange(index, 'text1', e.target.value)}
                      />
                    </Grid>
                    <Grid item>:</Grid>
                    <Grid item>
                      <TextField
                        label="Mapping"
                        name="Mapping"
                        value={row.text2}
                        onChange={(e) => handleChange(index, 'text2', e.target.value)}
                      />
                    </Grid>
                    <Grid item>
                      <IconButton onClick={() => handleDeleteRow(index)} color="secondary">
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
                <Box mt={2}>
                  <Button variant="contained" onClick={handleAddRow}>
                    Add Row
                  </Button>
                </Box>
              </Box>
              {/* </div> */}
              <div className="formInput">
                <label>Api Key</label>
                <TextField
                name="ApiKey"
                value={ApiKey}
                onChange={handleInputChange}
                />
              </div>
              <div className="formInput">
                <label>SSL</label>
                <FormControlLabel
              control={
              <Switch
              checked={Ssl}
              onChange={handleSwitchChange}
              name="Ssl"
              color='primary'
              />}
              />
              </div>
            </FormGroup>
        </FormControl>




    </div>
  );
};

export default Forms;